import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'arrayFilter',
    pure: false,
    standalone: false
})
export class ArrayFilter implements PipeTransform {
    transform(items: any[], filterCol:string, filter: string, negate:boolean, exact:boolean=false, onlineFilter:{field:string,value:string}=null): any {
        let newList = []

        if (!items || !filter ) {
            return items;
        }
        
        if ( items.length == 0){
            return items;
        }

        if ( filter == 'null'){
            if ( negate ){
                newList= items.filter(item=>item[filterCol]==null);
            }else{
                newList= items.filter(item=>item[filterCol]!=null);
            }
            
            
        }else{
            if (!exact){
                if ( negate ){
                    newList= items.filter(item => item[filterCol].toString().indexOf(filter) == -1);
                }else{
                    newList= items.filter(item => item[filterCol].toString().indexOf(filter) !== -1);
                }
            }else{
                if ( negate ){
                    newList= items.filter(item => item[filterCol].toString() != filter );
                }else{
                    newList= items.filter(item => item[filterCol].toString() == filter);
                }
            }
            
        }

        if ( onlineFilter != null ){
            newList= newList.filter(item => item[onlineFilter.field].toString().toLowerCase().indexOf(onlineFilter.value.toLowerCase()) > -1);
        }
        
        return newList;

    }

}